<template>
  <v-spacer
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'VSpacerWrapper',
  inheritAttrs: false
}
</script>
